import { Icon } from '@aibees/shared/components';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { BillingItemProps as Props } from './types';
import { Status } from '../information-card';

export const BillingItem = memo(({ className, item, action }: Props) => {
  const { date, interval, price } = item;

  const { palette } = useTheme();

  const statuses: Status[] = [
    {
      color: palette.success,
      value: 'Active',
      type: 'ACTIVE',
    },
    {
      color: palette.warning,
      value: 'Pending',
      type: 'PENDING',
    },
  ];
  const status = statuses.find((i) => i.type === 'PENDING');

  return (
    <Styled.Wrapper
      className={classnames('BillingItem', className)}
      sx={SX.root}
      direction="row"
      justifyContent="space-between"
    >
      <Stack direction="row" gap={1} alignItems="center">
        <Icon name="time-duration-15" sxx={SX.icon} size={20} />
        <Typography sx={SX.text1}>{date}</Typography>
        <Box sx={SX.box} />
        <Typography sx={SX.text1}>{interval}</Typography>
        <Box sx={SX.box} />
        <Typography sx={SX.text2}>${price}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap={0.5}>
        {status && (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={SX.status(status.color)}
          >
            {status?.value}
          </Stack>
        )}
        <Typography sx={SX.action}>
          {action === 'DOWNLOAD' ? 'download' : 'View Invoice'}
        </Typography>
      </Stack>
    </Styled.Wrapper>
  );
});

BillingItem.displayName = 'BillingItem';
